import { GridColDef } from '@mui/x-data-grid';
import { TDocument } from '../../../../../apis/documents/documents.interfaces';
import RowActions from '../../../../components/RowActions';
import { formatDateForSubmit } from '../../../../../utils/helpers';

export const getDocumentGridRowsToRender = (records: TDocument[]) => {
  return records;
};

export const getColumnsForDocumentGrid = (
  onRowClickHandler: (data: TDocument) => void
) => {
  const columns: GridColDef[] = [
    {
      field: 'documentName',
      headerName: 'Document Name',
      width: 200,
      renderCell: (params) => {
        const data = params.row as TDocument;
        return `${data?.documentName ?? '---'}`;
      },
    },
    {
      field: 'documentType',
      headerName: 'Type',
      width: 150,
      renderCell: (params) => {
        const data = params.row as TDocument;
        return `${data?.documentType ?? '---'}`;
      },
    },
    {
      field: 'status',
      headerName: 'Status',
      width: 120,
      renderCell: (params) => {
        const data = params.row as TDocument;
        return `${data?.status ?? '---'}`;
      },
    },
    {
      field: 'submissionDate',
      headerName: 'Submitted On',
      width: 150,
      renderCell: (params) => {
        const data = params.row as TDocument;
        return data?.submissionDate
          ? formatDateForSubmit(new Date(data.submissionDate))
          : '---';
      },
    },
    {
      field: 'verificationDate',
      headerName: 'Verified On',
      width: 150,
      renderCell: (params) => {
        const data = params.row as TDocument;
        return data?.verificationDate
          ? formatDateForSubmit(new Date(data.verificationDate))
          : '---';
      },
    },
    {
      field: 'remarks',
      headerName: 'Remarks',
      width: 200,
      renderCell: (params) => {
        const data = params.row as TDocument;
        return `${data?.remarks ?? '---'}`;
      },
    },
    {
      field: 'actions',
      headerName: 'Actions',
      width: 120,
      renderCell: (params) => {
        return (
          <RowActions record={params} onRowClickHandler={onRowClickHandler} />
        );
      },
    },
  ];
  return columns;
};
